export default "__VITE_ASSET__b0b157b6__"